import { IKgModelCard } from 'app/extreport/concierge/answering/kgModelCardTypes';

export const isBootstrapCard = (card: IKgModelCard): boolean => card.identity_id === 0;

export const bootstrapNounKey = (biTool: IKgModelCard['bi_tool'] | undefined, modelCount: number): string => {
    if (biTool === 'tableau') return 'bootstrap_noun_tableau';
    if (biTool === 'other') return 'bootstrap_noun_other';
    return modelCount === 1 ? 'bootstrap_noun_powerbi_one' : 'bootstrap_noun_powerbi';
};

export const neverAdded = (cards: IKgModelCard[]): boolean =>
    cards.length > 0 &&
    cards.every((card) => isBootstrapCard(card) || (!card.source_removed && card.registration_status === 'not_added'));
